import { render, staticRenderFns } from "./payment-type-missing.vue?vue&type=template&id=362b9b48&"
import script from "./payment-type-missing.vue?vue&type=script&lang=js&"
export * from "./payment-type-missing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports